import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { IStockGroup } from '../../interfaces';

interface IStockGroupColumnRendererParams extends ICellRendererParams {
  groups :IStockGroup[];
}
@Component({
  selector: 'lum-stock-group-column',
  templateUrl: './stock-group-column.component.html',
  styleUrls: ['./stock-group-column.component.scss'],
})
export class StockGroupColumnComponent implements ICellRendererAngularComp {
  private params :IStockGroupColumnRendererParams;
  private static renderedRows = new Set<string>();
  isExpanded :boolean = true;
  isParentGroupRow :boolean = false;
  group :IStockGroup | null = null;

  agInit(params :IStockGroupColumnRendererParams) :void {
    const uniqueRowId = this.getUniqueRowId(params);
    this.params = params;
    this.isParentGroupRow = params.node.group ?? false;
    this.group =
      params.groups.find((g :IStockGroup) => g.label === params.value) ?? null;
    if (!this.group) {
      this.group =
        params.groups.find((g :IStockGroup) => g.identifier === 0) ?? null;
    }

    if (
      !StockGroupColumnComponent.renderedRows.has(uniqueRowId) &&
      this.isParentGroupRow
    ) {
      this.params.node.setExpanded(this.isExpanded);
      StockGroupColumnComponent.renderedRows.add(uniqueRowId);
    }
  }

  toggleGroup() :void {
    if (this.isParentGroupRow) {
      this.isExpanded = !this.isExpanded;
      this.params.node.setExpanded(this.isExpanded);
    }
  }

  refresh(params :any) :boolean {
    return false;
  }

  private getUniqueRowId(params :IStockGroupColumnRendererParams) :string {
    return params.node.id?.toString() || '';
  }
}
